var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitalityEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.7493H4C3.86207 3.7493 3.75023 3.86142 3.75 3.9993V11.9993C3.75 12.1374 3.86193 12.2493 4 12.2493H12C12.1381 12.2493 12.25 12.1374 12.25 11.9993V7.9993H13.75V11.9993C13.75 12.9658 12.9665 13.7493 12 13.7493H4C3.0335 13.7493 2.25 12.9658 2.25 11.9993V3.9993C2.25023 3.033 3.03364 2.2493 4 2.2493H8V3.7493ZM10.6064 2.4241C11.4265 1.6041 12.7561 1.60405 13.5762 2.4241C14.396 3.24417 14.3961 4.57383 13.5762 5.39383L9.58105 9.38895L6.11621 9.88406L6.61133 6.41922L10.6064 2.4241ZM8.02539 7.12625L7.88379 8.11551L8.87402 7.97488L11.3486 5.4993L10.5 4.65164L8.02539 7.12625ZM12.5156 3.48465C12.2814 3.25039 11.9013 3.25043 11.667 3.48465L11.5605 3.5911L12.4092 4.43875L12.5156 4.33328C12.7498 4.09907 12.7497 3.71893 12.5156 3.48465Z",
    fill: "#05054B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalityEdit);
export default __webpack_public_path__ + "static/media/Vitality-edit.bde9e239f2d0e749f604c6c3545ed9d5.svg";
export { ForwardRef as ReactComponent };